import React, { useState } from "react";
import {
  StyledFilterBlock, StyledFilterBlockTitle,
  StyledFilterCloseBtn, StyledFilterDropdownWrapper,
  StyledFilterGroup,
  StyledFilterWrapper,
  StyledShowFilterBtn
} from "../../../elements/filter/styledFiter";
import Dropdown from "rc-dropdown";
import DefaultButton from "../../../styles/materialButtonStyle";
import { DelayInput } from "react-delay-input/lib/Component";
import MappedServicesFilter from "../../../elements/serviceReletionships/mappedServices/MappedServicesFilter";
import ProjectsSelect from "../../../elements/projects/ProjectsSelect";

const WalletsFilter = ({ filterData, setFilterData, t }) => {
  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "itemsPerPage": filterData["itemsPerPage"] ?? null,
    "currentTab": filterData["currentTab"] ?? null,
    "currency": null,
    "paymentSystem": null,
    "wallet": "",
    "tag": "",
    "connection.project.name": null,
    "connection.service.name": null,
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    if (filterData["currentTab"]) {
      DEFAULT_FILTER_DATA.currentTab = filterData["currentTab"];
    }

    setFilterData(DEFAULT_FILTER_DATA);
  };

  const handleChangeFilterData = (data, name) => {
    setFilterData(prev => ({
      ...prev,
      [name]: data,
      page: 1
    }));
  };

  const FilterList = () => {
    return (
      <>
        {visible && (
          <StyledFilterDropdownWrapper>
            <StyledFilterBlock actions>
              <StyledFilterGroup className="clear-btn">
                <DefaultButton
                  color="transparent"
                  onClick={handleClearFilter}
                >
                  {t("wallets.filter.clearBtn")}
                </DefaultButton>
              </StyledFilterGroup>
              <StyledFilterGroup className="close-btn">
                <StyledFilterCloseBtn onClick={() => setVisible(false)} />
              </StyledFilterGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("wallets.filter.filterBy")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock col="2">
              <ProjectsSelect
                checkedProjects={filterData["connection.project.name"]}
                setCheckedProjects={(data) => setFilterData({ ...filterData, "connection.project.name": data })}
                isObject={false}
                defaultOption={true}
              />
              <MappedServicesFilter
                checkedService={filterData["connection.service.name"]}
                setCheckedService={data => handleChangeFilterData(data, "connection.service.name")}

                checkedPaymentSystem={filterData["paymentSystem"]}
                setCheckedPaymentSystem={data => handleChangeFilterData(data, "paymentSystem")}

                checkedCurrency={filterData["currency"]}
                setCheckedCurrency={data => handleChangeFilterData(data, "currency")}
              />
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("wallets.filter.filterByAddress")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock col="2">
              <StyledFilterGroup>
                <label htmlFor="wallet">
                  {t("wallets.filter.wallet")}
                </label>
                <DelayInput
                  id="wallet"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "wallet": event.target.value, page: 1 })}
                  name="wallet"
                  value={filterData["wallet"]}
                  type="text"
                />
              </StyledFilterGroup>
              <StyledFilterGroup>
                <label htmlFor="tag">
                  {t("wallets.filter.tag")}
                </label>
                <DelayInput
                  id="tag"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "tag": event.target.value, page: 1 })}
                  name="tag"
                  value={filterData["tag"]}
                  type="text"
                />
              </StyledFilterGroup>
            </StyledFilterBlock>
          </StyledFilterDropdownWrapper>
        )}
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("wallets.filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default WalletsFilter;